import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M7.83 11l5.36-5.36-1.41-1.42L4 12l7.78 7.78 1.41-1.42L7.83 13H20v-2H7.83z"/>
  </SvgIcon>
);